import React, { useEffect, useState } from 'react'
import Icon from '../components/Icon'
import { useToast } from '../components/ToastProvider'
import contactImg from '../images/contact.svg'
import { Helmet } from 'react-helmet-async'

const EMPTY = { name: '', email: '', subject: '', message: '' }

function Contact() {
  const toast = useToast()
  const [form, setForm] = useState(EMPTY)
  useEffect(() => window.scrollTo(0, 0), [])

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))
  const submit = (e) => {
    e.preventDefault()
    toast("Message sent we'll reply within 24 hours.")
    setForm(EMPTY) // clear all fields after submit
  }

  return (
    <>
    <Helmet>
            <title>Contact Us | iLoveImgPdf</title>
    
            <meta
              name="description"
              content="iLoveImgPdf free online image & PDF tools. Compress, resize, crop, convert, merge, split, edit, sign and unlock your files right in the browser."
            />
    
            <meta
              name="keywords"
              content="Image,image tools, pdf tools, compress image, resize image, crop image, convert image, remove background, image to pdf, merge pdf, split pdf, compress pdf, pdf to word, word to pdf, pdf to excel, pdf to ppt, pdf to jpg, edit pdf, sign pdf, unlock pdf, protect pdf, rotate pdf, watermark pdf, free online tools"
            />
    
            <link
              rel="canonical"
              href="https://iloveimgpdf.com/contact"
            />
          </Helmet>
    <main className="view">
      <div className="wrap subpage">
        <div className="doc-page">
          <div className="doc-head center">
            <h1 className="eyebrow1">Contact Us</h1>
            {/* <h2>We'd love to hear from you.</h2> */}
            <p className="contact">Questions, feedback, or an idea for a tool we should add? Send a note and we'll get back to you, usually within a day.</p>
          </div>
          <div className="contact-grid">
            <div className="contact-art">
              <img src={contactImg} alt="Get in touch with iLoveImgPdf" />
            </div>
            <form className="panel form-panel" onSubmit={submit}>
              <div className="form-row">
                <div className="field"><label>Name</label><input className="in" type="text" placeholder="Your name" value={form.name} onChange={set('name')} /></div>
                <div className="field"><label>Email</label><input className="in" type="email" placeholder="you@example.com" value={form.email} onChange={set('email')} /></div>
              </div>
              <div className="field"><label>Subject</label><input className="in" type="text" placeholder="What's this about?" value={form.subject} onChange={set('subject')} /></div>
              <div className="field"><label>Message</label><textarea className="in" placeholder="Tell us a little more…" value={form.message} onChange={set('message')} /></div>
              <button type="submit" className="btn btn-c" style={{ width: '100%' }}>
                <Icon name="send" size={18} style={{ color: '#fff' }} />Send message
              </button>
            </form>
          </div>
        </div>
      </div>
    </main>
    </>
  )
}

export default Contact
